module.exports = __webpack_public_path__ + "img/bg-club-rise.09f4b8d4.jpg";